import { createContext, useContext } from "react";

export type NavDrawerContextValue = {
    open: () => void;
    close: () => void;
};

export const NavDrawerContext = createContext<NavDrawerContextValue | null>(
    null,
);

export function useNavDrawer(): NavDrawerContextValue {
    const ctx = useContext(NavDrawerContext);
    if (!ctx) {
        return {
            open: () => undefined,
            close: () => undefined,
        };
    }
    return ctx;
}
